import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import type SessionService from 'ember-simple-auth/services/session';

export default class NoAccessRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare session: SessionService;

  async beforeModel(transition: Transition) {
    await this.session.requireAuthentication(transition, 'login');
    this.navbarSettings.title = 'No Access';
  }
}
